import { root, id } from './order';

export const order = {
  ...root,
  id,
};
